import { splitDomains } from "app/services/searchAdsSpend/searchAdsSpendParams";
import { useSearchAdsSpendQuery } from "app/services/searchAdsSpend/useSearchAdsSpendQuery";

import type { IUseCostPerVisitDataParams } from "./types";
import { useSearchTrafficData } from "./useSearchTrafficData";

export const useCostPerVisitData = (params: IUseCostPerVisitDataParams, isShouldFetch: boolean = true) => {
    const {
        data: searchTrafficData,
        isLoading: isSearchTrafficLoading,
        isError: isSearchTrafficError,
        error: searchTrafficError,
    } = useSearchTrafficData(params, isShouldFetch);

    const {
        data: spendData,
        isLoading: isSpendLoading,
        isError: isSpendError,
        error: spendError,
    } = useSearchAdsSpendQuery(
        {
            country: Number(params.country),
            from: params.from,
            to: params.to,
            keys: splitDomains(params.keys),
            isWindow: params.isWindow,
            webSource: params.webSource,
        },
        { enabled: isShouldFetch },
    );

    const isLoading = isSearchTrafficLoading || isSpendLoading;
    const isError = isSearchTrafficError || isSpendError;
    const error = searchTrafficError || spendError;

    return {
        searchTrafficData,
        spendData,
        isLoading,
        isError,
        error,
        spendError,
    };
};
